'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { withRouter } from 'react-router-dom';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import TrackIntroductionPage from '../../components/TrackPage/TrackIntroductionPage';
import { getFirstContentForTrackUrl, getTrack, trackIsLoading } from '../../selectors/trackSelectors';
import ApiError from '../../components/Errors/ApiError';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS } from '../../constants/Tracking';
import TrackDeprecatedModal from '../../components/Modals/FeatureIntroModals/TrackDeprecatedModal';
import { isTrackDeprecated } from '../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TrackIntroPageContainer extends Component {
  componentDidMount() {
    const {
      trackId
    } = this.props;
    this.redirectToFirstContentIfNoIntro();
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: 'intro',
      trackId
    });
  }
  componentDidUpdate() {
    this.redirectToFirstContentIfNoIntro();
  }
  redirectToFirstContentIfNoIntro() {
    const {
      track
    } = this.props;
    if (track && !track.get('hasError') && !track.get('isRequesting') && !track.get('introVideo')) {
      this.handleNavigateToFirstContent();
    }
  }
  handleNavigateToFirstContent() {
    const {
      history,
      firstContentUrl
    } = this.props;
    history.replace(firstContentUrl);
  }
  render() {
    const {
      track,
      isLoading
    } = this.props;
    if (isLoading || !track.get('hasError') && !track.get('introVideo')) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 200
      });
    }
    if (track.get('hasError')) {
      return /*#__PURE__*/_jsx(ApiError, {
        error: track.get('recentError'),
        marker404: "COURSE_INTRO_VIEW_API_404",
        markerDefault: "COURSE_INTRO_VIEW_API_ERROR"
      });
    }
    const deprecationFinalDate = track.get('deprecationFinalDate');
    const deprecated = track.get('deprecated');
    const isDeprecated = isTrackDeprecated(deprecated, deprecationFinalDate);
    return /*#__PURE__*/_jsxs(NavMarker, {
      name: "COURSE_INTRO_VIEW_LOADED",
      children: [/*#__PURE__*/_jsx(TrackIntroductionPage, {
        track: track
      }), isDeprecated && /*#__PURE__*/_jsx(TrackDeprecatedModal, {
        cta: track.get('deprecationCta'),
        message: track.get('deprecationMessage'),
        trackId: track.get('id')
      })]
    });
  }
}
TrackIntroPageContainer.propTypes = {
  firstContentUrl: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  track: ImmutablePropTypes.map,
  trackId: PropTypes.string
};
function mapStateToProps(state, ownProps) {
  return {
    track: getTrack(state, ownProps),
    isLoading: trackIsLoading(state, ownProps),
    firstContentUrl: getFirstContentForTrackUrl(state, ownProps)
  };
}
export default withRouter(connect(mapStateToProps)(TrackIntroPageContainer));